<h2 mat-dialog-title>{{ data.title || 'Enter Parent PIN' }}</h2>
<mat-dialog-content>
  <div class="pin-display">{{enteredPin || '____'}}</div>
  <div *ngIf="showError" class="error-message">
    {{ errorMessage }}
  </div>
  <div class="pin-pad">
    <button mat-raised-button *ngFor="let num of numbers" 
            (click)="enterNumber(num)">{{num}}</button>
    <button mat-raised-button color="warn" 
            (click)="clear()">Clear</button>
    <button mat-raised-button 
            (click)="enterNumber(0)">0</button>
    <button mat-raised-button color="primary" 
            [disabled]="!isComplete()"
            (click)="submitPin()">Enter</button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" 
          [disabled]="!isComplete()"
          (click)="submitPin()">Verify</button>
</mat-dialog-actions>
